import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/bricolage-grotesque";
import "@fontsource-variable/geist";
import "@fontsource-variable/geist/wght-italic.css";
import "@fontsource-variable/geist-mono";
import App from "./App";
import { initializePageScroll } from "./lib/page-scroll";
import { applyTheme, resolveTheme } from "./lib/theme";
import "./styles/index.css";

applyTheme(resolveTheme());
const disposePageScroll = initializePageScroll();

if (import.meta.hot) import.meta.hot.dispose(disposePageScroll);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => undefined);
  });
}
